<template>
  <div>
    <Dialog v-model:value="dialogState" />
    <q-layout
      view="lhh lpR lFf"
      :class="{ 'grey-background': greyBackground }"
      @click="viewPortClickHandler"
    >
      <q-header
        v-if="!$route.meta.hideTitle"
        class="layout--header-container flex-center row q-px-lg"
        :style="headerStyle"
      >
        <div class="layout--header-inner-container">
          <q-toolbar-title>
            <div class="row items-center layout--header-title">{{ $route.meta.title }}</div>
          </q-toolbar-title>
          <user-notifications
            v-show="isFeatureOn('NOTIFICATIONS')"
            v-if="!$route.meta.hideNotifications"
          />
        </div>
      </q-header>
      <side-menu
        v-if="!$route.meta.hideSideMenu"
        :key="sideMenuForceRefreshKey"
      />
      <q-page-container
        class="layout-page--container"
        @contextmenu="closeSideMenu"
      >
        <left-drawer />
        <q-page
          class="layout--scroller-container inline row no-wrap"
          :style-fn="layoutStyleFn"
        >
          <q-resize-observer @resize="handlePageResize" />
          <router-view :page-size="size" />
        </q-page>
        <right-drawer class="right-drawer-high-resolution" />
      </q-page-container>
      <right-drawer class="right-drawer-low-resolution" />
    </q-layout>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import Dialog from '@/components/common/Dialog.vue';
import UserNotifications from '@/components/common/userNotifications/userNotifications.vue';
import { defineComponent, provide, ref, inject } from 'vue';
import { IKPageSize } from '@/types/injectionKeys';
import SideMenu from './sidemenu/sidemenu.vue';
import LeftDrawer from './LeftDrawer.vue';
import RightDrawer from './RightDrawer.vue';
import { IKRightDrawer } from './RightDrawer.InjectionKeys';

export default defineComponent({
  name: 'LayoutDefault',
  components: {
    Dialog,
    SideMenu,
    UserNotifications,
    LeftDrawer,
    RightDrawer,
  },
  setup() {
    const size = ref({ width: null, height: null });
    const sideMenuForceRefreshKey = ref(0);
    const rightDrawer = inject(IKRightDrawer);
    provide(IKPageSize, size);
    return { size, rightDrawer, sideMenuForceRefreshKey };
  },

  computed: {
    ...mapGetters({
      getCoordinatorLinkStatus: ['main/getCoordinatorLinkStatus'],
    }),

    headerStyle() {
      return {
        marginLeft: this.$store.getters['main/leftDrawer'] ? '329px' : null,
        marginRight: this.rightDrawer.drawer.value.component ? '400px' : null,
        transition: 'margin 0.3s',
      };
    },
    dialogState: {
      get() {
        const { name: routerName = '' } = this.$route;
        return !['login', 'enterLicense'].includes(routerName) && this.$store.getters['main/dialogOpen'];
      },
      set(value) {
        return this.$store.commit('main/dialogState', value);
      },
    },
    greyBackground() {
      return this.dialogState && this.$store.getters['main/dialogData'].grayBackground;
    },
  },

  mounted() {
    this.$store.commit('main/SET_LD_STATE', false);
    this.$store.commit('main/SET_LD_COMPONENT', { component: 'AgentTableFilters', title: 'Filters' });
  },
  methods: {
    handlePageResize(value) {
      this.size = value;
      this.$store.commit('main/pageSize', value);
    },
    viewPortClickHandler() {
      this.$eventHub.$emit('closeTooltip');
    },
    layoutStyleFn(offset) {
      const margin = this.$route.meta.hideMargin ? 0 : 3;
      const height = offset ? `calc(100vh - ${offset}px - ${margin * 2}px)` : `calc(100vh - ${margin * 2}px)`;
      const width = `calc(100% - ${margin * 2}px)`;
      return {
        minHeight: height,
        height,
        width,
        margin: `${margin}px`,
        paddingTop: 0,
      };
    },
    closeSideMenu() {
      this.sideMenuForceRefreshKey += 1;
    },
  },
});
</script>

<style lang="scss" scoped>
.layout-page--container {
  display: flex !important;
  background-color: $-system-app-background;
}
.layout--header-container {
  padding-left: 30px !important;
  height: 68px;
  padding-top: 12px;
  background: none !important;
  .layout--header-inner-container {
    max-width: 1624px;
    display: inline-flex;
    width: 100%;
    align-items: center;
  }
  .layout--header-title {
    color: $-text--dark;
    font-family: Gordita-Medium;
    font-size: 26px;
    font-weight: 500;
  }
}
.layout--scroller-container {
  width: 100%;
  &::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 3px;

    background-color: $-system-app-primary;
  }
}

@media (min-width: 1320px) and (max-width: 1920px) {
  .right-drawer-low-resolution {
    display: none;
  }
}

@media (min-width: 950px) and (max-width: 1319px) {
  .right-drawer-high-resolution {
    display: none;
  }
  .layout--header-container {
    margin-right: unset !important;
  }
}
.right-drawer-low-resolution {
  z-index: 2000;
  top: 0;
  position: fixed;
  box-shadow: -2px 0px 12px rgba(0, 0, 0, 0.2);
}
</style>
